type ApiMethods<V> = [
  promise: Promise<V>,
  resolver: (value: V) => void,
  rejecter: (reason?: unknown) => void,
];

/**
 * Allows a resolver to be set outside a promise constructor.
 *
 * @see https://codingbeautydev.com/blog/javascript-resolve-promise-from-outside/
 */
export const promiseResolver = <V>(): ApiMethods<V> => {
  let resolver = (_: V) => {};
  let rejecter = () => {};

  const promise = new Promise((res, rej) => {
    resolver = res;
    rejecter = rej;
  });

  return [promise, resolver, rejecter] as ApiMethods<V>;
};
